import { baseApi } from './baseApi';
import { RegisterPersonModel } from '../models/registerPersonModel';
import { UserInvitationModel } from '../models/userInvitationModel';

export async function inviteUserReq(userInvite: UserInvitationModel) {
  return baseApi.post('/officiating/user/invite', userInvite);
}

export async function invitationDetailsReq(invitationCode: string) {
  return baseApi.get(`/officiating/user/invitation-details/${invitationCode}`);
}

export async function registerUserReq(
  userDetails: RegisterPersonModel,
  invitationCode: string,
  image?: File,
) {
  const data = new FormData();
  image && data.append('file', image);
  data.append('userDetails', JSON.stringify(userDetails));
  data.append('invitationCode', invitationCode);
  return baseApi.post('/officiating/user/register', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
